import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { ConfirmationModal } from '../../../components/ConfirmationModal';
import { ProjectStatus } from '../../projects/projects.model';
import { ProjectImageAssignmentPolicyForm } from '../components/ProjectImageAssignmentPolicyForm';
import { IProjectDetailsBl } from '../projectDetails.bl';
import { ImageAssignmentPolicy } from '../projectDetails.models';
import { IProjectDetailsStore } from '../projectDetails.store';

export const ProjectImageAssignmentPolicyFormContainer = observer((): ReactElement => {
  const projectDetailsBl = useInjection(IProjectDetailsBl.$);
  const projectDetailsStore = useInjection(IProjectDetailsStore.$);

  const { t } = useTranslator();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(projectDetailsStore.imageAssignmentPolicy);

  const handlePolicyChangeConfirm = async (): Promise<void> => {
    await projectDetailsBl.updateImageAssignmentPolicyAsync(selectedPolicy);
    setShowConfirmationModal(false);
  };

  const handlePolicyChangeCancel = (): void => {
    setShowConfirmationModal(false);
    setSelectedPolicy(projectDetailsStore.imageAssignmentPolicy);
  };

  const handlePolicyChange = async (policy: ImageAssignmentPolicy): Promise<void> => {
    if (projectDetailsStore.status === ProjectStatus.Published) {
      setShowConfirmationModal(true);
      setSelectedPolicy(policy);
      return;
    }

    await projectDetailsBl.updateImageAssignmentPolicyAsync(policy);
  };

  return (
    <div className='project-image-assignment-policy-container'>
      <ProjectImageAssignmentPolicyForm
        onPolicyChange={handlePolicyChange}
        selectedPolicy={projectDetailsStore.imageAssignmentPolicy}
      />
      <ConfirmationModal
        confirmationHeader={'image_assignment_policy_change_header'}
        confirmationDescription={'image_assignment_policy_change_body'}
        onConfirm={handlePolicyChangeConfirm}
        onCancel={handlePolicyChangeCancel}
        showModal={showConfirmationModal}
        confirmationYes={'save'}
      >
        <p>
          <strong>{t('image_assignment_policy_change_note')}</strong>
        </p>
      </ConfirmationModal>
    </div>
  );
});
